// extracted by css-extract-rspack-plugin
export default {"dateAndIsSampleTemplateWrapper":"DescriptionContent_dateAndIsSampleTemplateWrapper__6PdZe","description":"DescriptionContent_description__aCpIC"};